import type {
  NavigationGuardNext,
  RouteLocationNormalizedGeneric,
  RouteLocationNormalizedLoadedGeneric
} from 'vue-router'

/**
 * Auth middleware - does nothing, just passes through
 * Used for the new landing routes to avoid fetching store data
 * until authentication is properly established
 */
export const auth = async (
  _to: RouteLocationNormalizedGeneric,
  _from: RouteLocationNormalizedLoadedGeneric,
  next: NavigationGuardNext
): Promise<void> => {
  // This middleware does nothing - it just allows the route to proceed
  // without checking authentication or initializing any store data
  next()
}
